import React, {useEffect} from "react"
import {Col, Row} from "@irati/ui/src/Layout"

import id from "@irati/utils/id"
import rewardWalletTracking from "@irati-tracking/wallet/rewardWallet"

import Container from "../styled/Container"
import Intro from "../../components/Reward/Intro"
import HeaderBalance from "../../components/Reward/HeaderBalance"
import Transactions from "../../components/StatementItems/Transactions"
import NewRewardModal from "../../components/NewRewardModal"

const RewardWallet = (props) => {
  useEffect(() => {
    rewardWalletTracking.viewRewardWallet()
  }, [])

  const idNamespace = id("reward-wallet", props, {force: true})

  return (
    <Container>
      <Row>
        <Col md={6} lg={5}>
          <Intro />
        </Col>
        <Col md={6} lg={7}>
          <HeaderBalance id={idNamespace} />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Transactions id={id} />
        </Col>
      </Row>
      <NewRewardModal />
    </Container>
  )
}

export default RewardWallet
